import { useState, useEffect, useContext } from 'react';
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import NuevoUsuario from './NuevoUsuario';
import TablaUsuario from './TablaUsuarios';
import { Button, Container, Spinner } from 'reactstrap';
import { Unidad } from '../../interfaces/Unidad';
import CatalogService from '../../services/CatalogService';
import AlertService from '../../services/AlertService';
import UsuarioService from '../../services/UsuarioService';
import { useCasUserContext } from '../../services/casUserContext';
import { UnauthorizedPage } from '../../pages/Error/ErrorUnauthorized';
import { PersonaInvDTO, VoidPersonaInvDTO } from '../../interfaces/Usuarios/PersonaInvDTO';
import { UserForm } from './UserForm';
import { Alert, FormControl, Grid, IconButton, TextField } from '@mui/material';
import { FaSearch } from "react-icons/fa";

interface opcion {
  value: string,
  label: string,
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Container>{children}</Container>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface UsuariosProps {
  pesta: number;
}

const usuarioService = new UsuarioService();
const catalogService = new CatalogService();
const alertService = new AlertService();
//export default function Usuarios(props: UsuariosProps){
export default function Usuarios() {

  //const [value, setValue] = React.useState(props.pesta);
  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const roles = casUserContext.userData.roles;
  const token = casUserContext.userData.token;
  const [value, setValue] = React.useState(0);
  const [busq, setBusq] = React.useState(0);
  const [usuario, setUsuario] = React.useState('');
  const [identificacion, setIdentificacion] = React.useState('');
  const [userInicial, setUserInicial] = useState<PersonaInvDTO>(() => VoidPersonaInvDTO())
  const [unidades, setUnidades] = useState<Array<Unidad>>([])
  const unidadesOpcion: Array<opcion> = Array<opcion>()
  useEffect(() => {
    const fetchData = async () => {
      if (usuarioService.authorizedByRol(142, roles)) {
        setValue(0);
      } else {
        setValue(1);
      }
      try {
        await catalogService.obtenerCatalogoUnidades()
          .then((data) => setUnidades(data.objDatos))
          .catch((error) => console.error(error))

      } catch (error) {
        console.error('Error:', error);
      }
    };
    fetchData();
  }, [])

  unidades.map((row) => {
    let opc: opcion = {
      value: row.idunidad.toString(),
      label: row.nombreunidad
    }
    unidadesOpcion.push(opc)
  })
  //#region Funciones
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleBusqChange = (event: React.SyntheticEvent, newValue: number) => {
    setBusq(newValue);
  };
  const handleUsuarioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsuario(event.target.value);
  }
  const handleNuevoUsuario = (event: React.SyntheticEvent) => {
    setUserInicial(VoidPersonaInvDTO());
  };
  const handleIdentificaionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIdentificacion(event.target.value);
  }
  const findUsuarioByEmail = async () => {
    try {
      const resp = await usuarioService.GetUsuarioByEmail(token, usuario)
      if (resp.status.isSuccessfully) {
        setUserInicial(resp.data)
      } else {
        alertService.alertaAdvertenciaList("Alerta", resp.status.messages)
      }
    } catch (error) {
      console.error('Error:', error);
      alertService.alertaAdvertencia("Alerta", "Problemas con el servicio de usuario.")
    }
  };
  const findUsuarioByIdentificacion = async () => {
    try {
      const resp = await usuarioService.GetUserByIdentificacion(token, identificacion)
      if (resp.status.isSuccessfully) {
        setUserInicial(resp.data)
      } else {
        alertService.alertaAdvertenciaList("Alerta", resp.status.messages)
      }
    } catch (error) {
      console.error('Error:', error);
      alertService.alertaAdvertencia("Alerta", "Problemas con el servicio de usuario.")
    }
  };
  const handleResponse = async (responseData: PersonaInvDTO) => {
    // Manejar la respuesta aquí
    setUserInicial(VoidPersonaInvDTO());
}; 
  //#endregion
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Nuevo Usuario" {...a11yProps(0)} />
          <Tab label="Resumen Usuarios" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0} >
        {usuarioService.authorizedByRol(142, roles) ?
          <Box>
            {userInicial.idpersona == 0 ?
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={busq} onChange={handleBusqChange} aria-label="basic tabs example">
                  <Tab label="Usuario" {...a11yProps(0)} />
                  <Tab label="Identificacion" {...a11yProps(1)} />
                </Tabs>
                <CustomTabPanel value={busq} index={0} >
                  <Grid container>
                    <Grid item xs={12} sm={12} md={10}>
                      <FormControl sx={{ m: 0.15 }} fullWidth>
                        <TextField
                          id="usuario"
                          label="Usuario"
                          variant="outlined"
                          value={usuario}
                          onChange={handleUsuarioChange}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={1} justifyContent="center"
                      alignItems="center"
                      sx={{ m: 1 }}
                    >
                      <IconButton color='primary' onClick={findUsuarioByEmail}><FaSearch /></IconButton>
                    </Grid>
                  </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={busq} index={1} >
                  <Grid container>
                    <Grid item xs={12} sm={12} md={10}>
                      <FormControl sx={{ m: 0.15 }} fullWidth>
                        <TextField
                          id="identifiacion"
                          label="Identifiación"
                          variant="outlined"
                          value={identificacion}
                          onChange={handleIdentificaionChange}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={1} justifyContent="center"
                      alignItems="center"
                      sx={{ m: 1 }}
                    >
                      <IconButton color='primary' onClick={findUsuarioByIdentificacion}><FaSearch /></IconButton>
                    </Grid>
                  </Grid>
                </CustomTabPanel>
              </Box>
              : <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Button style={{ backgroundColor: '#517ED3', color: 'white', width: '50%' }} onClick={handleNuevoUsuario}>Buscar Nuevo</Button>
              </Box>
            }
            {userInicial.idpersona > 0 ?
              <UserForm usuario={userInicial} token={token} onResponse={handleResponse}/>
              :
              <Alert severity="info">Para registrar un nuevo usuario, primero realice una búsqueda.</Alert>
            }
          </Box>
          : <UnauthorizedPage />
        }
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TablaUsuario rowsPerPage={[5, 10, 25, 100]} />
      </CustomTabPanel>
    </Box>
  );

}